import { UserEntity, parseEntityRef } from "@backstage/catalog-model";
import { useApi, identityApiRef } from "@backstage/core-plugin-api";
import { catalogApiRef } from "@backstage/plugin-catalog-react";
import { useEffect, useState } from "react";

export const useCurrentUser = () => {
  const identityApi = useApi(identityApiRef);
  const catalogApi = useApi(catalogApiRef);
  const [response, setResponse] = useState<UserEntity>();

  useEffect(() => {
    (async () => {
      const identity = await identityApi.getBackstageIdentity();
      const { name: userId } = parseEntityRef(identity.userEntityRef);
      const { token } = await identityApi.getCredentials();
      const user = await catalogApi.getEntityByRef(`User:default/${userId}`, {
        token,
      });
      setResponse(user as UserEntity);
    })();
  }, [identityApi, catalogApi]);

  return response;
};
